module.exports = __webpack_public_path__ + "img/wxlcon.95eca895.png";